import ArticleLayout from '@/pages/article/components/ArticleLayout';
import { allArticles } from '@/mocks/articles';

export default function BestSugargooFindsPage() {
  const article = allArticles.find(a => a.slug === 'best-sugargoo-finds')!;
  return <ArticleLayout article={article} />;
}